import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterItemDiff } from '@/api/model/interfaces';

export default class RegisterItemDiffOdata extends OdataManager<RegisterItemDiff> {}
